export const ANIMATION_INTERVAL_SECONDS = 49;
export const ANIMATION_SPEED_SECONDS = 10;
export const MESSAGE_INTERVAL_SECONDS = 29;
export const MESSAGE_SPEED_SECONDS = 2;
